import Cookies from 'js-cookie';
import z from 'zod';

const COOKIE_NAME = 'download-app-banner';
export const SESSIONS_COUNT = 3;

const schema = z.object({
    closed: z.boolean(),
    downloaded: z.boolean(),
    sessions: z.number(),
});

type BannerCookieType = z.infer<typeof schema>;

export const setCookie = (values: BannerCookieType): string => {
    const cookie = JSON.stringify(values);
    Cookies.set(COOKIE_NAME, cookie);

    return cookie;
};

export const getCookie = (): BannerCookieType => {
    let cookie = Cookies.get(COOKIE_NAME);

    if (cookie === undefined) {
        cookie = setCookie({ closed: false, downloaded: false, sessions: SESSIONS_COUNT });
    }

    return schema.parse(JSON.parse(cookie));
};
